import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25abb7a4&lang=pug&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "~/assets/styles/corporate.sass?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {RestModel: require('/Users/n.yiannopoulos/Documents/Projects/el-translations-fullstack/resources/components/rest-model.vue').default,SvgSymbol: require('/Users/n.yiannopoulos/Documents/Projects/el-translations-fullstack/resources/components/svg-symbol.vue').default,RestProp: require('/Users/n.yiannopoulos/Documents/Projects/el-translations-fullstack/resources/components/rest-prop.vue').default,RestImg: require('/Users/n.yiannopoulos/Documents/Projects/el-translations-fullstack/resources/components/rest-img.vue').default,RestRichText: require('/Users/n.yiannopoulos/Documents/Projects/el-translations-fullstack/resources/components/rest-rich-text.vue').default,CmsEdit: require('/Users/n.yiannopoulos/Documents/Projects/el-translations-fullstack/resources/components/cms-edit.vue').default,StatsBox: require('/Users/n.yiannopoulos/Documents/Projects/el-translations-fullstack/resources/components/stats-box.vue').default,Trustmarks: require('/Users/n.yiannopoulos/Documents/Projects/el-translations-fullstack/resources/components/trustmarks.vue').default})
